import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { EguardConfigService } from '../../../../core/services/config.service';
import { CognitoUtil } from '../../services/cognito.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Subscription } from 'rxjs/Subscription';
import { User } from '../../../shared/models/user.model';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { MatDialog } from '@angular/material';
import { TimeOutDialogComponent } from '../../dialog/time-out-dialog/time-out-dialog.component';
import { DataShareService } from '../../services/data-share.service';
import { HeaderTitleService } from 'app/services/header-title.service';
import { CacheService } from 'app/services/cache.service';
import * as moment from 'moment';

@Component({
  selector: 'eguard-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class EguardToolbarComponent implements OnInit {

  headerTitle = [
    { id: 1, icon: 'dashboard', title: 'Dashboard' },
  ]
  userStatusOptions: any[];
  user: any;
  title: string;
  icon: string;

  userState$: Observable<any>;
  private userStateSubscription: Subscription;
  showSpinner: boolean;
  horizontalNav: boolean;
  fullScreen = false;

  subscription: Subscription;
  idleState = '';
  lastPing?: Date = null;
  lastLoginTime: string;
  currentTime = new Date()
  firstTime: boolean;
  constructor(
    private router: Router,
    private eguardConfig: EguardConfigService,
    private idle: Idle,
    private keepalive: Keepalive,
    private shareService: DataShareService,
    private cognito: CognitoUtil,
    public dialog: MatDialog,
    private headerService: HeaderTitleService
  ) {
    // this.userState$ = store.select("userDetails");
    this.lastLoginTime = localStorage.getItem('lastLoginTime');

    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.showSpinner = true;
      }
      if (event instanceof NavigationEnd) {
        this.showSpinner = false;
      }
    });

    this.eguardConfig.onSettingsChanged.subscribe(settings => {
      this.horizontalNav = settings.layout.navigation === 'top';
    });

    this.subscription = this.headerService.getHeader().subscribe(item => {
      this.title = item.text
      this.icon = item.icon
    });

    // Setting idle time to 50 mins i.e., 3000 seconds
    idle.setIdle(3000);
    idle.setTimeout(15);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => this.idleState = null);
    idle.onTimeout.subscribe(() => {
      this.shareService.send('closeMe')
      this.logout()
    });
    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!';
      if (this.firstTime = true) {
        this.warningDialog();
      }
      this.firstTime = false;
    });
    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
      this.shareService.send(this.idleState);
    });



    keepalive.interval(15);

    keepalive.onPing.subscribe(() => {
      this.idleState = null;
      // this.warningDialog();
      this.lastPing = new Date();
    });

    this.reset();

  }
  reset() {
    this.idle.watch();
  }
  warningDialog(): void {
    let dialogRef = this.dialog.open(TimeOutDialogComponent, {
      width: '350px',
      data: { idleState: this.idleState }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if(result) {
        this.cognito.refreshUserToken();
      }
      else {
        this.idleState = result;
      }
    });
  }

  logout() {
    localStorage.removeItem('userDetails');
    this.cognito.logout();

    this.router.navigate(['login']);
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  search(value) {
    // Do your search here...
  }


  ngOnInit() {
    if (!this.user) {
      let userDetails = localStorage.getItem('userDetails');
      if (userDetails) {
        this.user = JSON.parse(userDetails);
      }
    }

    if (this.lastLoginTime) {
      if (moment().valueOf() < moment(this.lastLoginTime).add(30, 'm').valueOf()) {
        if (this.lastLoginTime) {
          localStorage.removeItem('lastLoginTime');
        }
        localStorage.setItem('lastLoginTime', this.currentTime.toISOString());
      } else {
        // this.sampleInterval = setInterval(() => {
        //   if (this.isNavStart && this.isNavStart !== null && this.isNavStart === false) {
        //     clearInterval(this.sampleInterval);
        localStorage.removeItem('userDetails');
        this.cognito.logout();
        this.router.navigate(['login']);
        //   }
        // }, 1000);
      }
    } else {
      localStorage.setItem('lastLoginTime', this.currentTime.toISOString());
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/main/shared/components/toolbar/toolbar.component.ts